
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Select,
    useCRUDController,
    Card
} from '../../ui/ot'
import { useTranslation } from "react-i18next";

const BudgetAndQuantityControlForm = ({
    axiosMode,
    keyPrefix = "cataloging.budget_and_quantity_control",
    propsForm,
    field,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {}
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        LibraryController.getData({})

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {
        let formValues = null;
        formValues = form.getFieldsValue();
        formValues ={
            ...formValues,
            remaining_budget :formValues?.estimate_cost - formValues?.actual_cost
        }
        form.setFieldsValue({
            ...formValues
        })
    };

    const setFieldValue = (name, value) => {
        form.setValue(name, value);
    };
    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };
    const LibraryController = useCRUDController({
        apiRoute: "/koha/library"
    })
    useEffect(() => {
        setDataInitialization();
    }, []);


    useEffect(() => {
        // (propsForm ?? form).setFieldsValue({ ...defaultValue })
        setCount((pre) => pre + 1)
    }, [])

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                field={field}
                                // initialValues={initialValues}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={setFieldValue}
                                setCount={setCount}
                                libraryOptions={LibraryController?.ResponseData}
                                axiosMode={axiosMode}
                            />
                        </Col>
                    </Row>

                </Form >

            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    axiosMode,
    keyPrefix = "cataloging.budget_and_quantity_control",
    field,
    initialValues = {},
    show,
    getAnyFormValue,
    count,
    setFieldValue,
    setCount,
    libraryOptions
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <>
            <Row gutter={[8, 8]}>
                <Col span={24}>
                    <Form.Item
                        {...field}
                        name={[field?.name ?? '', 'budget_control_id']}
                        fieldKey={[field?.fieldKey, 'budget_control_id']}
                        hidden={true}
                        labelCol={24}
                        wrapperCol={24}
                    >
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        label={t('fiscal_year')}
                        {...field}
                        name={[field?.name ?? '', 'year']}
                        fieldKey={[field?.fieldKey, 'year']}
                        labelCol={24}
                        wrapperCol={24}

                    >
                        <Input type="year" disabled={axiosMode === "patch"} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        {...field}
                        label={t('estimated_expense')}
                        name={[field?.name ?? '', 'estimate_cost']}
                        fieldKey={[field?.fieldKey, 'estimate_cost']}
                        labelCol={24}
                        wrapperCol={24}
                    >
                        <Input type="number" />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        {...field}
                        label={t('actual_expense')}
                        name={[field?.name ?? '', 'actual_cost']}
                        fieldKey={[field?.fieldKey, 'actual_cost']}
                        labelCol={24}
                        wrapperCol={24}
                    >
                        <Input type="number" />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        {...field}
                        label={t('remaining_budget')}
                        name={[field?.name ?? '', 'remaining_budget']}
                        fieldKey={[field?.fieldKey, 'remaining_budget']}
                        labelCol={24}
                        wrapperCol={24}
                    >
                        <Input type="number" disabled={true} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        {...field}
                        label={t('personal_recommendation_quota')}
                        name={[field?.name ?? '', 'recommend_budget']}
                        fieldKey={[field?.fieldKey, 'recommend_budget']}
                        labelCol={24}
                        wrapperCol={24}
                    >
                        <Input type="number" />
                    </Form.Item>
                </Col>


            </Row>
        </>
    );
};





export default BudgetAndQuantityControlForm;
